/**
 * High Grade Gift Slider — CSS marquee on desktop.
 * Mobile arrows step one slide; the track does not auto-scroll.
 */
(function () {
  'use strict';

  var SNAP_MS = 420;
  var instances = [];

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function gapOf(el) {
    var styles = window.getComputedStyle(el);
    return toNumber(styles.columnGap || styles.gap, 0);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function bindSection(section) {
    if (!section || section.dataset.hggBound === 'true') return;

    var viewport = section.querySelector('.high-grade-gift-slider__viewport');
    var scroller = section.querySelector('.high-grade-gift-slider__scroller');
    var track = section.querySelector('.high-grade-gift-slider__track');
    var original = section.querySelector('[data-set="original"]');
    if (!viewport || !scroller || !track || !original) return;

    section.dataset.hggBound = 'true';

    var speed = Math.max(1, toNumber(section.dataset.speed, 40));
    var nudge = 0;
    var snap = null;
    var rafId = 0;

    function loopWidth() {
      return original.offsetWidth;
    }

    function slideStep() {
      var slide = original.querySelector('.high-grade-gift-slider__slide');
      if (!slide) return 160;
      var width = slide.getBoundingClientRect().width || slide.offsetWidth || 148;
      return width + gapOf(original);
    }

    function normalizeNudge() {
      var width = loopWidth();
      if (width <= 0) return;
      while (nudge >= width) nudge -= width;
      while (nudge < 0) nudge += width;
    }

    function renderNudge() {
      if (nudge) {
        scroller.style.transform = 'translate3d(' + -nudge + 'px, 0, 0)';
      } else {
        scroller.style.removeProperty('transform');
      }
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function syncLoop() {
      var width = loopWidth();
      if (width <= 0) return;
      section.style.setProperty('--hgg-loop', width + 'px');
      section.style.setProperty('--hgg-duration', width / speed + 's');
      track.style.animation = 'none';
      if (!isDesktop()) return;
      void track.offsetWidth;
      track.style.animation = '';
    }

    function fillTrack() {
      track.querySelectorAll('[data-set="extra"]').forEach(function (node) {
        node.remove();
      });

      var viewportWidth = viewport.getBoundingClientRect().width;
      var setWidth = original.offsetWidth;
      if (setWidth <= 0) return;

      var sets = track.querySelectorAll('.high-grade-gift-slider__set');
      var total = 0;
      sets.forEach(function (set) {
        total += set.offsetWidth;
      });

      while (total < viewportWidth * 2 + 80) {
        var extra = original.cloneNode(true);
        extra.setAttribute('data-set', 'extra');
        extra.setAttribute('aria-hidden', 'true');
        extra.querySelectorAll('[id]').forEach(function (node) {
          node.removeAttribute('id');
        });
        track.appendChild(extra);
        total += extra.offsetWidth;
      }

      syncLoop();
    }

    function startSnap(direction) {
      var distance = slideStep() * direction;
      if (!distance) return;

      if (snap) {
        snap.to += distance;
        snap.from = nudge;
        snap.start = performance.now();
        return;
      }

      snap = {
        from: nudge,
        to: nudge + distance,
        start: performance.now(),
        duration: SNAP_MS
      };
      if (!rafId) rafId = window.requestAnimationFrame(tick);
    }

    function consumeNudge() {
      var raw = section.getAttribute('data-hgg-nudge');
      if (!raw) return;
      section.removeAttribute('data-hgg-nudge');
      var direction = parseInt(raw, 10);
      if (direction) startSnap(direction);
    }

    function tick(now) {
      consumeNudge();

      if (snap) {
        var t = Math.min(1, (now - snap.start) / snap.duration);
        nudge = snap.from + (snap.to - snap.from) * easeOutCubic(t);
        if (t >= 1) {
          nudge = snap.to;
          normalizeNudge();
          snap = null;
        }
        renderNudge();
        rafId = window.requestAnimationFrame(tick);
        return;
      }

      rafId = 0;
    }

    var nudgePoll = window.setInterval(consumeNudge, 80);

    fillTrack();
    renderNudge();

    section.querySelectorAll('[data-hgg-step]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        section.setAttribute('data-hgg-nudge', btn.getAttribute('data-hgg-step'));
        consumeNudge();
      });
    });

    var resizeTimer = 0;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        fillTrack();
        normalizeNudge();
        renderNudge();
      }, 150);
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('load', fillTrack);

    instances.push({
      section: section,
      destroy: function () {
        if (rafId) window.cancelAnimationFrame(rafId);
        window.clearInterval(nudgePoll);
        window.removeEventListener('resize', onResize);
        window.removeEventListener('load', fillTrack);
        section.dataset.hggBound = 'false';
      }
    });
  }

  function destroySection(section) {
    instances = instances.filter(function (item) {
      if (item.section === section) {
        item.destroy();
        return false;
      }
      return true;
    });
  }

  function init() {
    document.querySelectorAll('.high-grade-gift-slider').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.classList.contains('high-grade-gift-slider')
      ? event.target
      : event.target.querySelector('.high-grade-gift-slider');
    if (section) bindSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.classList.contains('high-grade-gift-slider')
      ? event.target
      : event.target.querySelector('.high-grade-gift-slider');
    if (section) destroySection(section);
  });
})();
